(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("string-template-parser", [], factory);
	else if(typeof exports === 'object')
		exports["string-template-parser"] = factory();
	else
		root["string-template-parser"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_QUOTED_STRING_REGEX = /^('((?:[^'\\]|\\.)*)'|'((?:[^'\\]|\\.)*)$|"((?:[^"\\]|\\.)*)"|"((?:[^"\\]|\\.)*)$)/;
function parseStringTemplateGenerator(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ESCAPE, ESCAPE = _c === void 0 ? /^\\/ : _c, _d = _b.VARIABLE_START, VARIABLE_START = _d === void 0 ? /^\${\s*/ : _d, _e = _b.VARIABLE_END, VARIABLE_END = _e === void 0 ? /^\s*}/ : _e, _f = _b.PIPE_START, PIPE_START = _f === void 0 ? /^\s*\|\s*/ : _f, _g = _b.PIPE_PARAMETER_START, PIPE_PARAMETER_START = _g === void 0 ? /^\s*:\s*/ : _g, _h = _b.QUOTED_STRING, QUOTED_STRING = _h === void 0 ? exports.DEFAULT_QUOTED_STRING_REGEX : _h, _j = _b.QUOTED_STRING_TEST, QUOTED_STRING_TEST = _j === void 0 ? null : _j, _k = _b.QUOTED_STRING_GET_AND_ADVANCE, QUOTED_STRING_GET_AND_ADVANCE = _k === void 0 ? null : _k, _l = _b.QUOTED_STRING_IN_PARAMETER_TEST, QUOTED_STRING_IN_PARAMETER_TEST = _l === void 0 ? null : _l, _m = _b.QUOTED_STRING_IN_PARAMETER_GET_AND_ADVANCE, QUOTED_STRING_IN_PARAMETER_GET_AND_ADVANCE = _m === void 0 ? null : _m;
    var quotedStringTest = QUOTED_STRING_TEST || (function (remainingString) { return QUOTED_STRING.test(remainingString); });
    var quotedStringGetAndAdvance = QUOTED_STRING_GET_AND_ADVANCE || getQuotedStringAndAdvanceForRegex(QUOTED_STRING);
    var quotedStringInParameterTest = QUOTED_STRING_IN_PARAMETER_TEST || (function (remainingString) { return QUOTED_STRING.test(remainingString); });
    var quotedStringInParameterGetAndAdvance = QUOTED_STRING_IN_PARAMETER_GET_AND_ADVANCE || getQuotedStringAndAdvanceForRegex(QUOTED_STRING);
    return function parseStringTemplate(input) {
        var remainingString = input;
        var parsedString = { literals: [], variables: [] };
        var parseState = 0 /* Literal */;
        var currentLiteral = '';
        var currentVariable = { name: '', pipes: [] };
        var currentPipe = { name: '', parameters: [] };
        var currentPipeParameter = '';
        var existsCurrentVariable = false;
        var existsCurrentPipe = false;
        var existsCurrentPipeParameter = false;
        while (remainingString && remainingString.length > 0) {
            switch (parseState) {
                case 0 /* Literal */:
                    if (ESCAPE.test(remainingString)) {
                        currentLiteral += getEscapedCharacter();
                        continue;
                    }
                    if (VARIABLE_START.test(remainingString)) {
                        parseState = 1 /* Variable */;
                        newCurrentVariable();
                        parsedString.literals.push(currentLiteral);
                        currentLiteral = '';
                        skipMatch(VARIABLE_START);
                        continue;
                    }
                    currentLiteral += remainingString[0];
                    advance();
                    break;
                case 1 /* Variable */:
                    if (ESCAPE.test(remainingString)) {
                        currentVariable.name += getEscapedCharacter();
                        continue;
                    }
                    if (testVariableEnd() || testPipeStart())
                        continue;
                    if (quotedStringTest(remainingString)) {
                        currentVariable.name += quotedStringGetAndAdvance(remainingString, advance);
                        continue;
                    }
                    currentVariable.name += remainingString[0];
                    advance();
                    break;
                case 2 /* Pipe */:
                    if (ESCAPE.test(remainingString)) {
                        currentPipe.name += getEscapedCharacter();
                        continue;
                    }
                    if (testVariableEnd() || testPipeParameterStart() || testPipeStart())
                        continue;
                    if (quotedStringTest(remainingString)) {
                        currentPipe.name += quotedStringGetAndAdvance(remainingString, advance);
                        continue;
                    }
                    currentPipe.name += remainingString[0];
                    advance();
                    break;
                case 3 /* PipeParameter */:
                    if (ESCAPE.test(remainingString)) {
                        currentPipeParameter += getEscapedCharacter();
                        continue;
                    }
                    if (testVariableEnd() || testPipeParameterStart() || testPipeStart())
                        continue;
                    if (quotedStringInParameterTest(remainingString)) {
                        currentPipeParameter += quotedStringInParameterGetAndAdvance(remainingString, advance);
                        continue;
                    }
                    currentPipeParameter += remainingString[0];
                    advance();
                    break;
            }
        }
        if (existsCurrentPipeParameter)
            currentPipe.parameters.push(currentPipeParameter);
        if (existsCurrentPipe)
            currentVariable.pipes.push(currentPipe);
        if (existsCurrentVariable)
            parsedString.variables.push(currentVariable);
        parsedString.literals.push(currentLiteral);
        return parsedString;
        function advance(length) {
            if (length === void 0) { length = 1; }
            remainingString = remainingString.substr(length);
        }
        function skipMatch(regex) {
            if (regex === void 0) { regex = /^/; }
            advance(remainingString.match(regex)[0].length);
        }
        function getEscapedCharacter() {
            var escapedCharacter;
            skipMatch(ESCAPE);
            escapedCharacter = remainingString.length > 0 ? remainingString[0] : '';
            advance();
            return escapedCharacter;
        }
        function newCurrentVariable(_a) {
            var _b = (_a === void 0 ? {} : _a).isNull, isNull = _b === void 0 ? false : _b;
            currentVariable = { name: '', pipes: [] };
            existsCurrentVariable = !isNull;
        }
        function deleteCurrentVariable() {
            parsedString.variables.push(currentVariable);
            newCurrentVariable({ isNull: true });
        }
        function newCurrentPipe(_a) {
            var _b = (_a === void 0 ? {} : _a).isNull, isNull = _b === void 0 ? false : _b;
            currentPipe = { name: '', parameters: [] };
            existsCurrentPipe = !isNull;
        }
        function deleteCurrentPipe() {
            currentVariable.pipes.push(currentPipe);
            newCurrentPipe({ isNull: true });
        }
        function newCurrentPipeParameter(_a) {
            var _b = (_a === void 0 ? {} : _a).isNull, isNull = _b === void 0 ? false : _b;
            currentPipeParameter = '';
            existsCurrentPipeParameter = !isNull;
        }
        function deleteCurrentPipeParameter() {
            currentPipe.parameters.push(currentPipeParameter);
            newCurrentPipeParameter({ isNull: true });
        }
        function testVariableEnd() {
            if (!VARIABLE_END.test(remainingString))
                return false;
            skipMatch(VARIABLE_END);
            if (parseState >= 3 /* PipeParameter */)
                deleteCurrentPipeParameter();
            if (parseState >= 2 /* Pipe */)
                deleteCurrentPipe();
            if (parseState >= 1 /* Variable */)
                deleteCurrentVariable();
            parseState = 0 /* Literal */;
            return true;
        }
        function testPipeStart() {
            if (!PIPE_START.test(remainingString))
                return false;
            skipMatch(PIPE_START);
            if (parseState >= 3 /* PipeParameter */)
                deleteCurrentPipeParameter();
            if (parseState >= 2 /* Pipe */)
                deleteCurrentPipe();
            if (parseState >= 1 /* Variable */)
                newCurrentPipe();
            parseState = 2 /* Pipe */;
            return true;
        }
        function testPipeParameterStart() {
            if (!PIPE_PARAMETER_START.test(remainingString))
                return false;
            skipMatch(PIPE_PARAMETER_START);
            if (parseState >= 3 /* PipeParameter */)
                deleteCurrentPipeParameter();
            if (parseState >= 2 /* Pipe */)
                newCurrentPipeParameter();
            parseState = 3 /* PipeParameter */;
            return true;
        }
    };
}
exports.parseStringTemplateGenerator = parseStringTemplateGenerator;
exports.parseStringTemplate = parseStringTemplateGenerator();
function getQuotedStringAndAdvanceForRegex(regex) {
    return function (remainingString, advance) {
        var quotedStringMatch = remainingString.match(regex);
        advance(quotedStringMatch[0].length);
        return quotedStringMatch.slice(2).join('').replace('\\\\', '\\');
    };
}
exports.getQuotedStringAndAdvanceForRegex = getQuotedStringAndAdvanceForRegex;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(0));
__export(__webpack_require__(3));


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var parser_1 = __webpack_require__(0);
function DEFAULT_GET_VALUE(variables) {
    return function (variableName) {
        return variables.hasOwnProperty(variableName)
            ? variables[variableName]
            : variableName.split('.').reduce(function (value, current) { return value.hasOwnProperty(current) ? value[current] : ''; }, variables);
    };
}
function getParsedVariable(variable, variables, pipes, getValue) {
    if (getValue === void 0) { getValue = DEFAULT_GET_VALUE(variables); }
    var variableStartValue = getValue(variable.name);
    return variable.pipes.reduce(function (variableValue, pipe) {
        return pipes.hasOwnProperty(pipe.name) ?
            pipes[pipe.name](variableValue, pipe.parameters) :
            variableValue;
    }, variableStartValue == null ? '' : variableStartValue);
}
function evaluateParsedString(parsedString, variables, pipes, getValue) {
    if (getValue === void 0) { getValue = DEFAULT_GET_VALUE(variables); }
    if (parsedString.literals.length === 0)
        return '';
    return parsedString.literals.slice(1).reduce(function (result, literal, index) {
        return "" + result + getParsedVariable(parsedString.variables[index], variables, pipes, getValue) + literal;
    }, parsedString.literals[0]);
}
exports.evaluateParsedString = evaluateParsedString;
function evaluateStringTemplate(input, variables, pipes) {
    return evaluateParsedString(parser_1.parseStringTemplate(input), variables, pipes);
}
exports.evaluateStringTemplate = evaluateStringTemplate;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js